import request from '../request'
import { objectToQueryString } from '../../components/Dashboard/DataEntry/helpers/objectToQueryString'

export const getAnalyticsCurriculumCurrentProgress = (code) =>
  request.get(`/analytics/curriculum/${code}/current/progress`).then((res) => res)

export const getAnalyticsCurriculumCurrent = (code) =>
  request.get(`/analytics/curriculum/${code}/current`).then((res) => res)

export const getAnalyticsCurriculumByField = (code, type, id, data) =>
  request.get(`/analytics/curriculum/${code}/by-${type}/${id}`, data).then((res) => res)

export const generateDataForAnalyticsCurriculum = (code, data) =>
  request.post(`/analytics/curriculum/${code}/generate-data`, data).then((res) => res)

export const getSettingModule = (type, data) =>
  request.get(`/analytics/curriculum/setting/${type}`, data).then((res) => res)

export const updateSetting = (data) => request.put(`/analytics/curriculum/setting`, data).then((res) => res)

export const getAllModules = (code, module) =>
  request.get(`/analytics/curriculum/${code}/${module}`).then((res) => res)

export const createModule = (code, module, data) =>
  request.post(`/analytics/curriculum/${code}/${module}`, data).then((res) => res)

export const updateModule = (code, module, id, data) =>
  request.put(`/analytics/curriculum/${code}/${module}/${id}`, data).then((res) => res)

export const deleteModule = (code, module, id) =>
  request.delete(`/analytics/curriculum/${code}/${module}/${id}`).then((res) => res)

export const getHistory = (code, data) =>
  request.get(`/analytics/curriculum/${code}/history?${objectToQueryString(data)}`).then((res) => res)

export const deleteHistory = (code, historyId) =>
  request.delete(`/analytics/curriculum/${code}/history/${historyId}`).then((res) => res)

export const getAnalyticsCurriculumByFieldHistory = (code, historyId, type, id, data) =>
  request.get(`/analytics/curriculum/${code}/history/${historyId}/by-${type}/${id}`, data).then((res) => res)

export const getClassesHistory = (code, historyId, skip, limit, data) =>
  request
    .post(`/analytics/curriculum/${code}/history/${historyId}/classes/skip/${skip}/limit/${limit}`, data)
    .then((res) => res)

export const getStudentsHistory = (code, historyId, skip, limit, data) =>
  request
    .post(`/analytics/curriculum/${code}/history/${historyId}/students/skip/${skip}/limit/${limit}`, data)
    .then((res) => res)
